import { api } from '@/modules/api'
import store from '@/store'

export class SignalR {
  constructor (AccessToken, DeviceId) {
    this.url = api.signalR.connection()
    this.AccessToken = AccessToken
    this.DeviceId = DeviceId
  }
  connect () {
    this.createHubConnection(this.url)
    this.proxy = this.hubConnection.createHubProxy('user-action-tracking-hub')
    this.startConnection(this.AccessToken, this.DeviceId)
  }
  stopConnection () {
    this.hubConnection.stop()
  }
  invokeActionOccured () {
    this.proxy.invoke('action-occured')
      .done(() => {
        store.dispatch('invokeStatus', true)
      })
      .fail(() => {
        store.dispatch('invokeStatus', false)
        console.warn('Something went wrong')
      })
  }
  createHubConnection (url) {
    this.hubConnection = require('signalr-no-jquery').hubConnection(url)
  }
  startConnection (AccessToken, DeviceId) {
    this.hubConnection.qs = { authorization: AccessToken, deviceId: DeviceId }
    this.proxy.on('OnLoggedOut', () => {
      store.dispatch('deuthenticateUser')
    })
    this.hubConnection.start()
      .done(() => {
        store.dispatch('connected')
        console.log('Now connected, connection ID=' + this.hubConnection.id)
        this.invokeActionOccured()
        this.hubConnection.disconnected(() => {
          store.dispatch('disconnected')
        })
      })
      .fail(function (err) {
        console.log(err, 'Could not connect')
      })
  }
}



//////////////////
// WEBPACK FOOTER
// ./plugins/signalr-no-jquery.js
// module id = null
// module chunks = 